import fetch from 'isomorphic-fetch';

export const API_URL = process.env.NEXT_PUBLIC_API_URL || 'https://main-api.vmnk.in';
export const API_URL_CALLER = 'https://main-api.vmnk.in';
export const API_MANAGER_URL = process.env.NEXT_PUBLIC_NEW_MANAGER_API_URL || 'https://main-api.vmnk.in';
// export const API_URL = 'https://api.venuemonk.com';

export default function callApi(endpoint, method = 'get', body, api_url) {
  let token = typeof window === 'undefined' ? '' : window.localStorage.getItem('token');
  let headers = {};
  headers['content-type'] = 'application/json';
  if (token && token !== '') {
    headers.Authorization = `Bearer ${token}`;
  }
  return fetch(`${api_url || API_URL}/${endpoint}`, {
    headers: headers,
    method,
    body: JSON.stringify(body),
    referrer: '',
    referrerPolicy: 'origin-when-cross-origin'
  }).then(response => response.json().then(json => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        return Promise.reject(json);
      }
      return json;
    })
    .then(
      response => response,
      error => error
    );
}

export function newcallApi(endpoint, method = 'get', body, api_url) {
  let token = typeof window === 'undefined' ? '' : window.localStorage.getItem('token');
  let headers = {};
  headers['content-type'] = 'application/json';
  if (token && token !== '') {
    headers.Authorization = `Bearer ${token}`;
  }
  return fetch(`${api_url || API_URL_CALLER}/${endpoint}`, {
    headers: headers,
    method,
    body: JSON.stringify(body),
    referrer: '',
    referrerPolicy: 'origin-when-cross-origin'
  }).then(response => response.json().then(json => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        return Promise.reject(json);
      }
      return json;
    })
    .then(
      response => response,
      error => error
    );
}

export function callManagerApi(endpoint, method = 'get', body, api_url) {
  let token = typeof window === 'undefined' ? '' : window.localStorage.getItem('token');
  let headers = {};
  headers['content-type'] = 'application/json';
  if (token && token !== '') {
    headers.Authorization = `Bearer ${token}`;
  }
  return fetch(`${api_url || API_MANAGER_URL}/${endpoint}`, {
    headers: headers,
    method,
    body: JSON.stringify(body),
    referrer: '',
    referrerPolicy: 'origin-when-cross-origin'
  }).then(response => response.json().then(json => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        return Promise.reject(json);
      }
      return json;
    })
    .then(
      response => response,
      error => error
    );
}

export function callSelfAPI(endpoint, method = 'get', body) {
  let headers = {};
  headers['content-type'] = 'application/json';
  return fetch(`${endpoint}`, {
    headers: headers,
    method,
    body: JSON.stringify(body),
    referrer: '',
    referrerPolicy: 'origin-when-cross-origin'
  }).then(response => response.json().then(json => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok) {
        return Promise.reject(json);
      }
      return json;
    })
    .then(
      response => response,
      error => error
    );
}
